// Mirrors the server allowlist in supabase/functions/preview-rehearsal/handler.ts.
export const ALLOWED_PATTERNS = [
  "Emotional Pressure", "Guilt Induction", "Gaslighting", "Blame Shift", "DARVO",
  "Triangulation", "Shame Attack", "Invalidation", "Deflection", "Passive Aggression",
  "Victim Reversal", "Emotional Blackmail",
];

export const FREE_PREVIEW_PATTERN_MAP: Record<string, string> = {
  "Perception Questioning": "Gaslighting",
  "Reaction Reframing": "Invalidation",
  "Turning It Around": "Blame Shift",
  "Leveraging Past Sacrifice": "Guilt Induction",
  "Withdrawal Pressure": "Emotional Blackmail",
  "Global Criticism": "Shame Attack",
  "Apology Shift": "Invalidation",
  "Benchmarking Against Others": "Triangulation",
  "Appealing to Consensus": "Triangulation",
};

export function mapFreePreviewPattern(label: string): string {
  const mapped = Object.entries(FREE_PREVIEW_PATTERN_MAP).find(([variant]) => variant.toLowerCase() === label.toLowerCase());
  return mapped?.[1] ?? ALLOWED_PATTERNS.find(pattern => pattern.toLowerCase() === label.toLowerCase()) ?? "Emotional Pressure";
}

type Msg = { role: string; content: string };

/** Builds the only body shape the public demo accepts. */
export function buildPreviewRehearsalBody(message: string, turn: number, pattern?: string, prior: Msg[] = []) {
  const body: Record<string, unknown> = {
    message: message.trim().slice(0, 1000),
    turn: Math.min(3, Math.max(1, turn)),
  };
  const match = ALLOWED_PATTERNS.find((p) => p.toLowerCase() === pattern?.trim().toLowerCase());
  if (match) body.pattern = match;
  const history = prior
    .filter((m) => m.content?.trim())
    .slice(-4)
    .map((m) => ({ role: m.role === "assistant" ? "assistant" : "user", content: m.content.slice(0, 600) }));
  if (history.length) body.messages = history;
  return body;
}
